var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99847 19.9813C5.63252 19.8764 4.33463 19.3426 3.29013 18.4561C2.24562 17.5696 1.50791 16.3758 1.18233 15.0451C0.856744 13.7144 0.959938 12.3148 1.47717 11.0462C1.99441 9.77766 2.89924 8.70494 4.06247 7.98125C4.30998 6.05134 5.25227 4.27776 6.71299 2.99241C8.17371 1.70706 10.0528 0.998047 11.9985 0.998047C13.9442 0.998047 15.8232 1.70706 17.284 2.99241C18.7447 4.27776 19.687 6.05134 19.9345 7.98125C21.0977 8.70494 22.0025 9.77766 22.5198 11.0462C23.037 12.3148 23.1402 13.7144 22.8146 15.0451C22.489 16.3758 21.7513 17.5696 20.7068 18.4561C19.6623 19.3426 18.3644 19.8764 16.9985 19.9813V20.0003H6.99847V19.9813ZM12.9985 12.0003H15.9985L11.9985 7.00025L7.99847 12.0003H10.9985V16.0003H12.9985V12.0003Z",
    fill: "#E3D9FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/fileUpload.d4373040.svg";
export { ForwardRef as ReactComponent };